import JobsService from './JobsService'

let instance

export default function JobsServiceProvider () {
  if (!instance) {
    instance = new JobsService()
  }

  return instance
}



// WEBPACK FOOTER //
// ./src/api/jobs/JobsServiceProvider.js